/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exceptions_TitleInputs */



/**
* | output |
* | --- |
* | "Switched off" |
*
* @param {Meetings_Exceptions_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exceptions_title = /** @type {((inputs?: Meetings_Exceptions_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exceptions_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Uitgeschakeld")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désactivé")
	return /** @type {LocalizedString} */ ("Switched off")
});